// @flow
import * as React from 'react';
import { Field } from 'redux-form';
import { Hidden } from './base';

const HiddenField = ({ name, value }: {name: string, value: *}) =>
    <Field name={name} component={Hidden} defaultValue={value} />;

export default HiddenField;
